import moment from 'moment'

export const convertTimezone = {
    utcToLocal: function (date, time=true) {
        var stillUtc = moment.utc(date).toDate();
        if(!time) {
            return moment(stillUtc).local();
        }
        return  moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss');
    },
    utcToLocalDate: function (date, time=true) {
        var stillUtc = moment.utc(date).toDate();
        if(!time) {
            return moment(stillUtc).local();
        }
        return  moment(stillUtc).local().format('YYYY-MM-DD');
    }, 
    localToUtc: function (date, time=true) {
        if(!time) {
            return moment(date).utc();
        }
        return moment(date).utc().format('YYYY-MM-DD HH:mm:ss');
    }
};



// WEBPACK FOOTER //
// ./src/common/tenancy/convertTimezone.js